import { useState, useEffect } from 'react';

import { ContinueButton, Input, InputWithConfirm } from 'shared-components';

import { Q } from '../../../../store/student/types';
import { IOtherName } from '../../../../types';

interface IProps {
  index: number;
  givenName: string;
  givenNameSubText?: string;
  surname: string;
  surnameSubText?: string;
  surnameHelpText?: string;
  reason: string;
  onSaveAndClose: (otherName: IOtherName) => void;
}

const OtherNames = (props: IProps) => {
  const { index, onSaveAndClose } = props;
  const [givenName, setGivenName] = useState(props.givenName);
  const [surname, setSurname] = useState(props.surname);
  const [reason, setReason] = useState(props.reason);
  const [complete, setComplete] = useState(props.givenName !== '' && props.surname !== '' && props.reason !== '');

  const saveAndClose = () => {
    onSaveAndClose({
      givenName,
      surname,
      reason
    });
  };

  const handleOnSaveAndCloseClick = () => {
    saveAndClose();
  };

  useEffect(() => {
    setComplete(givenName !== '' && surname !== '' && reason !== '');
  }, [givenName, surname, reason]);

  return (
    <>
      <Input
        key={`${Q.GIVEN_NAME}-${index}`}
        id={`${Q.GIVEN_NAME}-${index}`}
        value={givenName}
        subText={props.givenNameSubText}
        label={'Given Names'}
        onChange={(evt: any) => setGivenName(evt.currentTarget.value)}
        mb={6}
      />

      <Input
        key={`${Q.SURNAME}-${index}`}
        id={`${Q.SURNAME}-${index}`}
        value={surname}
        inputHelperText={props.surnameHelpText}
        subText={props.surnameSubText}
        label={`Family Name`}
        onChange={(evt: any) => setSurname(evt.currentTarget.value)}
        mb={6}
      />

      <Input
        key={`${Q.OTHER_NAME_REASON}-${index}`}
        id={`${Q.OTHER_NAME_REASON}-${index}`}
        value={reason}
        label={'Reason for alternative name or name change'}
        onChange={(evt: any) => setReason(evt.currentTarget.value)}
        mb={6}
      />

      <ContinueButton index={index} complete={complete} handleOnSaveAndCloseClick={handleOnSaveAndCloseClick} />
    </>
  );
};

export default OtherNames;
